module.exports = "/dist/b3362875067300abedb7a8fb97903258.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-800italic.woff
// module id = 138
// module chunks = 0